<app-spinner [visible]="isSpinnerVisible"></app-spinner>

<div class="p-20">
  <div class="clearfix">
    <form class="inline">
      <button type="button" (click)="Export('TEXT')" class="btn btn-sm btn-outline-secondary ml-2 h-100">Copy</button>
      <button type="button" (click)="Export('CSV')" class="btn btn-sm btn-outline-secondary ml-2 h-100">CSV</button>
      <button type="button" (click)="Export('EXCEL')" class="btn btn-sm btn-outline-secondary ml-2 h-100">Excel</button>
      <button type="button" (click)="Export('PRINT')" class="btn btn-sm btn-outline-secondary ml-2 h-100">Print</button>
    </form>
    <br>

    <table id="selectedColumn" class="table table-striped table-hover table-sm" cellspacing="0"
      width="100%">
      <thead>
        <tr>
          <th class="th">Mois</th>
          <th class="th">Total consommés</th>
          <th class="th">Total facturable</th>
          <th class="th">Premium ajoutés</th>
          <th class="th">Lowcost ajoutés</th>
          <th class="th">Forfait</th>
          <th class="th">Postpaid</th>
        </tr>
      </thead>
      <tbody>
        @for (c of conso; track c) {
<tr>
          <th>{{c.date}}</th>
          <td>{{-1 * c.premiumcons}}
            @if (c.lowcostcons<0) {
<span> / {{-1 * c.lowcostcons}}</span>
}
          </td>
          <th>{{c.total}}</th>
          <td>{{c.premium}}</td>
          <td>{{c.lowcost}}</td>
          <td>{{c.forfait}} @if (c.forfaitC>0) {
<span>({{c.forfaitC}})</span>
}</td>
          <td>{{c.postpaid}} @if (c.postpaidC>0) {
<span>({{c.postpaidC}})</span>
}</td>
        </tr>
}
      </tbody>
    </table>

  </div>
</div>
